import React from "react";
import "./style.scss";
import casinoDaysTwoLines from "../../images/Casino-Days-Logo-Two-Lines-Gradient-Text-600x372.png";
import casinoDaysTwoLinesWhite from "../../images/Casino-Days-Logo-Two-Lines-White-Text-600x372.png";
import casinoDaysTwoLinesBg from "../../images/Casino-Days-Two-Lines-Gradient-BG-600x600.png";
import casinoDaysTwoLinesBg2 from "../../images/Casino-Days-Two-Lines-Gradient-BG-800x480.png";
import casinoDaysTwoLinesWhiteBg from "../../images/Casino-Days-Two-Lines-White-BG-600x600.png";
import casinoDaysTwoLinesWhiteBg2 from "../../images/Casino-Days-Two-Lines-White-BG-800x480.png";
import luckySpinsTwoLinesBlack from "../../images/Lucky-Spins-Logo-Two-Lines-Black-Text-480x280.png";
import luckySpinsTwoLinesYellow from "../../images/Lucky-Spins-Logo-Two-Lines-Yellow-Text-480x280.png";
import luckySpinsBGYellow from "../../images/Lucky-Spins-Two-Lines-BG-Yellow-600x600.png";
import luckySpinsBGYellow2 from "../../images/Lucky-Spins-Two-Lines-BG-Yellow-800x480.png";
import luckySpinsPattern600 from "../../images/Lucky-Spins-Two-Lines-Pattern-Yellow-600x600.png";
import luckySpinsPattern800 from "../../images/Lucky-Spins-Two-Lines-Pattern-Yellow-800x480.png";
import buustiKasinoWhite from "../../images/Buusti-Kasino-Logo-White-Text-628x280.png";
import buustiKasinoBlue from "../../images/Buusti-Kasino-Logo-Blue-Text-628x280.png";
import buustiKasinoBgBlue from "../../images/Buusti-Kasino-BG-Blue-600x600.png";
import buustiKasinoBgBlue2 from "../../images/Buusti-Kasino-BG-Blue-800x480.png";
import buustiKasinoBgWhite from "../../images/Buusti-Kasino-BG-White-600x600.png";
import buustiKasinoBgWhite2 from "../../images/Buusti-Kasino-BG-White-800x480.png";
import bigBoostGold from "../../images/Big-Boost-Logo-Two-Lines-Gold-Text-568x352.png";
import bigBoostRed from "../../images/Big-Boost-Logo-Two-Lines-Red-Text-568x352.png";
import bigBoostWhite from "../../images/Big-Boost-Logo-Two-Lines-White-Text-568x352.png";
import bigBoostBgBlue from "../../images/Big-Boost-Two-Lines-BG-Blue-600x600.png";
import bigBoostBgBlue2 from "../../images/Big-Boost-Two-Lines-BG-Blue-800x480.png";
import bigBoostPattern from "../../images/Big-Boost-Two-Lines-BG-Pattern-800x480.png";
import bigBoostBgRed from "../../images/Big-Boost-Two-Lines-BG-Red-600x600.png";
import bigBoostBgRed2 from "../../images/Big-Boost-Two-Lines-BG-Red-800x480.png";
import rakettiTransparentPink from "../../images/Raketti-Transparent-Pink-150x70.png";
import rakettiTransparentYellow from "../../images/Raketti-Transparent-Yellow-150x70.png";
import rakettiTransparentPink600 from "../../images/Raketti-Transparent-Pink-600x600.png";
import rakettiTransparentPink800 from "../../images/Raketti-Transparent-Pink-800x480.png";
import rakettiTransparentYellow600 from "../../images/Raketti-Transparent-Yellow-600x600.png";
import rakettiTransparentYellow800 from "../../images/Raketti-Transparent-Yellow-800x480.png";
import rocketRichesLogo from "../../images/rocket-riches-logo.png";
import rocketRichesH from "../../images/Rocket-Riches-H.png";
import rocketRichesV from "../../images/Rocket-Riches-V.png";
import rocketRichesBgBlack300x300 from "../../images/RR-BG-Black-300x300.png";
import rocketRichesBgBlack400x240 from "../../images/RR-BG-Black-400x240.png";
import rocketRichesBgPink300x300 from "../../images/RR-BG-Pink-300x300.png";
import rocketRichesBgPink400x240 from "../../images/RR-BG-Pink-400x240.png";
import rocketRichesBgYellow300x300 from "../../images/RR-BG-Yellow-300x300.png";
import rocketRichesBgYellow400x240 from "../../images/RR-BG-Yellow-400x240.png";
import rocketRichesGreenText from "../../images/RR-Green-Text-300x140.png";
import rocketRichesPinkText from "../../images/RR-Pink-Text-300x140.png";
import rocketRichesYellowText from "../../images/RR-Yellow-Text-300x140.png";
import paratiisiLogoMandarine256x40 from "../../images/Paratiisi-Logo-Mandarine-Burst-256x40.png";
import paratiisiLogoDragon256x40 from "../../images/Paratiisi-Logo-Dragon-Burst-256x40.png";
import paratiisiBGPattern300x140 from "../../images/Paratiisi-BG-Pattern-300x140.png";
import paratiisiBGPattern200x100 from "../../images/Paratiisi-BG-Paradise-200x100.png";
import paratiisiBGParadise300x140 from "../../images/Paratiisi-BG-Paradise-300x140.png";
import paratiisiBGParadise200x100 from "../../images/Paratiisi-BG-Paradise-200x100.png";
import paratiisiBGMagnolia300x140 from "../../images/Paratiisi-BG-Magnolia-Burst-300x140.png";
import paratiisiBGMagnolia200x100 from "../../images/Paratiisi-BG-Magnolia-Burst-200x100.png";
import paratiisiBGImage300x140 from "../../images/Paratiisi-BG-Image-300x140.png";
import paratiisiBGImage200x100 from "../../images/Paratiisi-BG-Image-200x100.png";
import paratiisiBGBlackberry300x140 from "../../images/Paratiisi-BG-Blackberry-300x140.png";
import paratiisiBGBlackberry200x100 from "../../images/Paratiisi-BG-Blackberry-200x100.png";
import bigLuckyGreenBGGoldWhite200x100 from "../../images/big-lucky-green-bg-gold-white-200x100.png";
import bigLuckyGreenBGGoldWhite300x140 from "../../images/big-lucky-green-bg-gold-white-300x140.png";
import bigLuckyGreenBGGoldWhite400x240 from "../../images/big-lucky-green-bg-gold-white-400x240.png";
import bigLuckyWhiteBGGreen200x100 from "../../images/big-lucky-white-bg-green-200x100.png";
import bigLuckyWhiteBGGreen300x140 from "../../images/big-lucky-white-bg-green-300x140.png";
import bigLuckyWhiteBGGreen400x240 from "../../images/big-lucky-white-bg-green-400x240.png";
import bigLuckyIconGreenBGGold1024x1024 from "../../images/big-lucky-icon-green-bg-gold-1024x1024-1024x1024.png";
import bigLuckyIconWhiteBGGreen1024x1024 from "../../images/big-lucky-icon-white-bg-green-1024x1024-1024x1024.png";
import bigLuckyVerticalGreenBGGoldWhite300x300 from "../../images/big-lucky-vertical-green-bg-gold-white-300x300.png";
import bigLuckyVerticalGreenBGGoldWhite400x240 from "../../images/big-lucky-vertical-green-bg-gold-white-400x240.png";
import bigLuckyVerticalWhiteBGGreen300x300 from "../../images/big-lucky-vertical-white-bg-green-300x300.png";
import bigLuckyVerticalWhiteBGGreen400x240 from "../../images/big-lucky-vertical-white-bg-green-400x240.png";
import ruhtinasBlueBgGold200x89 from "../../images/ruhtinas-blue-bg-gold-200x89.png";
import ruhtinasBlueBgGold200x100 from "../../images/ruhtinas-blue-bg-gold-200x100.png";
import ruhtinasBlueBgGold300x140 from "../../images/ruhtinas-blue-bg-gold-300x140.png";
import ruhtinasBlueBgGold400x240 from "../../images/ruhtinas-blue-bg-gold-400x240.png";
import ruhtinasCrownLogoBlueBgGold400x240 from "../../images/ruhtinas-crown+logo-blue-bg-gold-400x240.png";
import ruhtinasCrownLogoWhiteBgGold400x240 from "../../images/ruhtinas-crown+logo-white-bg-gold-400x240.png";
import ruhtinasVerticalBlueBgDarkGold300x300 from "../../images/ruhtinas-vertical-blue-bg-dark-gold-300x300.png";
import ruhtinasVerticalTransparentBgDarkGold250x250 from "../../images/ruhtinas-vertical-transparent-bg-dark-gold-250x250.png";
import ruhtinasVerticalTransparentBgGold250x250 from "../../images/ruhtinas-vertical-transparent-bg-gold-250x250.png";
import ruhtinasVerticalTransparentBgGold300x300 from "../../images/ruhtinas-vertical-transparent-bg-gold-300x300.png";
import ruhtinasVerticalWhiteBgGold300x3001 from "../../images/ruhtinas-vertical-white-bg-gold-300x300-1.png";
import ruhtinasVerticalWhiteBgGold300x300 from "../../images/ruhtinas-vertical-white-bg-gold-300x300.png";
import ruhtinasWhiteBgGold200x89 from "../../images/ruhtinas-white-bg-gold-200x89.png";
import ruhtinasWhiteBgGold200x100 from "../../images/ruhtinas-white-bg-gold-200x100.png";
import ruhtinasWhiteBgGold300x140 from "../../images/ruhtinas-white-bg-gold-300x140.png";
import ruhtinasWhiteBgGold400x240 from "../../images/ruhtinas-white-bg-gold-400x240.png";
import regalRushBlueBGGold200x89 from "../../images/regal-rush-blue-bg-gold-200x89.png";
import regalRushBlueBGGold200x100 from "../../images/regal-rush-blue-bg-gold-200x100.png";
import regalRushBlueBGGold300x140 from "../../images/regal-rush-blue-bg-gold-300x140.png";
import regalRushBlueBGGold420x240 from "../../images/regal-rush-blue-bg-gold-400x240.png";
import regalRushCrownLogoBlueBGGold400x240 from "../../images/regal-rush-crown+logo-blue-bg-gold-400x240.png";
import regalRushCrownLogoWhiteBGGold400x240 from "../../images/regal-rush-crown+logo-white-bg-gold-400x240.png";
import regalRushVerticalBlueBGDarkGold300x300 from "../../images/regal-rush-vertical-blue-bg-dark-gold-300x300.png";
import regalRushVerticalTransparentBGDarkGold250x250 from "../../images/regal-rush-vertical-transparent-bg-dark-gold-250x250.png";
import regalRushVerticalTransparentBGGold250x250 from "../../images/regal-rush-vertical-transparent-bg-gold-250x250.png";
import regalRushVerticalTransparentBGGold300x300 from "../../images/regal-rush-vertical-transparent-bg-gold-300x300.png";
import regalRushVerticalWhiteBGGold300x3001 from "../../images/regal-rush-vertical-white-bg-gold-300x300-1.png";
import regalRushVerticalWhiteBGGold300x300 from "../../images/regal-rush-vertical-white-bg-gold-300x300.png";
import regalRushWhiteBGGold200x89 from "../../images/regal-rush-white-bg-gold-200x89.png";
import regalRushWhiteBGGold200x100 from "../../images/regal-rush-white-bg-gold-200x100.png";
import regalRushWhiteBGGold300x140 from "../../images/regal-rush-white-bg-gold-300x140.png";
import regalRushWhiteBGGold400x240 from "../../images/regal-rush-white-bg-gold-400x240.png";
import panosta80x80 from "../../images/panosta-80x80.png";
import panosta100x100 from "../../images/panosta-100x100.png";
import panosta120x120 from "../../images/panosta-120x120.png";
import panosta150x150 from "../../images/panosta-150x150.png";
import panostasvg80x80 from "../../images/panosta-svg-80x80.svg";
import panostasvg100x100 from "../../images/panosta-svg-100x100.svg";
import panostasvg120x120 from "../../images/panosta-svg-100x100.svg";
import panostasvg150x150 from "../../images/panosta-svg-150x150.svg";
import panostasvg250x100 from "../../images/panosta-svg-250x100.svg";
import panostasvg300x100 from "../../images/panosta-svg-300x100.svg";
import panostasvg600x200 from "../../images/panosta-svg-600x200.svg";
import panostabackground from "../../images/panosta-background.svg";
import panostawhitebackground from "../../images/Panosta-white-background.svg";
import chillSpins80x80Dark from "../../images/chill-spins-80x80-dark.png";
import chillSpins80x80Transparent from "../../images/chill-spins-80x80-transparent.png";
import chillSpins120x120Dark from "../../images/chill-spins-120x120-dark.png";
import chillSpins120x120Transparent from "../../images/chill-spins-120x120-transparent.png";
import chillSpins150x150Dark from "../../images/chill-spins-150x150-dark.png";
import chillSpins150x150Transparent from "../../images/chill-spins-150x150-transparent.png";
import chillSpins300x300Dark from "../../images/chill-spins-300x100-dark.png";
import chillSpins300x300Transparent from "../../images/chill-spins-300x100-transparent.png";
import chillSpins600x200Dark from "../../images/chill-spins-600x200-dark.png";
import chillSpins600x200Transparent from "../../images/chill-spins-600x200-transparent.png";
import chillSpins1024x458Dark from "../../images/chill-spins-1024x458-dark.png";
import chillSpins1024x458Transparent from "../../images/chill-spins-1024x458-transparent.png";



export const Downloads = () => {
  return (
    <div className="logos-content">
      <div className="logos-header">
        <h5 className="logos-title">
          Casino Days Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={casinoDaysTwoLines} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={casinoDaysTwoLines} download='casinoDaysTwoLines'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={casinoDaysTwoLinesWhite} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={casinoDaysTwoLinesWhite} download='casinoDaysTwoLinesWhite'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={casinoDaysTwoLinesBg} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={casinoDaysTwoLinesBg} download='casinoDaysTwoLinesBg'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={casinoDaysTwoLinesBg2} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={casinoDaysTwoLinesBg2} download='casinoDaysTwoLinesBg2'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={casinoDaysTwoLinesWhiteBg} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={casinoDaysTwoLinesWhiteBg} download='casinoDaysTwoLinesWhiteBg'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={casinoDaysTwoLinesWhiteBg2} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={casinoDaysTwoLinesWhiteBg2} download='casinoDaysTwoLinesWhiteBg2'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Lucky Spins Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={luckySpinsTwoLinesBlack} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={luckySpinsTwoLinesBlack} download='luckySpinsTwoLinesBlack'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={luckySpinsTwoLinesYellow} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={luckySpinsTwoLinesYellow} download='luckySpinsTwoLinesYellow'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={luckySpinsPattern600} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={luckySpinsPattern600} download='luckySpinsPattern600'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={luckySpinsPattern800} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={luckySpinsPattern800} download='luckySpinsPattern800'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={luckySpinsBGYellow} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={luckySpinsBGYellow} download='luckySpinsBGYellow'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={luckySpinsBGYellow2} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={luckySpinsBGYellow2} download='luckySpinsBGYellow2'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Buusti Kasino Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={buustiKasinoWhite} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={buustiKasinoWhite} download='buustiKasinoWhite'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={buustiKasinoBlue} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={buustiKasinoBlue} download='buustiKasinoBlue'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={buustiKasinoBgBlue} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={buustiKasinoBgBlue} download='buustiKasinoBgBlue'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={buustiKasinoBgBlue2} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={buustiKasinoBgBlue2} download='buustiKasinoBgBlue2'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={buustiKasinoBgWhite} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={buustiKasinoBgWhite} download='buustiKasinoBgWhite'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={buustiKasinoBgWhite2} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={buustiKasinoBgWhite2} download='buustiKasinoBgWhite2'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Big Boost Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostGold} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostGold} download='bigBoostGold'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostRed} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostRed} download='bigBoostRed'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostWhite} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostWhite} download='bigBoostWhite'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostBgBlue} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostBgBlue} download='bigBoostBgBlue'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostBgBlue2} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostBgBlue2} download='bigBoostBgBlue2'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostPattern} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostPattern} download='bigBoostPattern'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostBgRed} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostBgRed} download='bigBoostBgRed'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigBoostBgRed2} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigBoostBgRed2} download='bigBoostBgRed2'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Raketti Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rakettiTransparentPink} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rakettiTransparentPink} download='rakettiTransparentPink'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rakettiTransparentYellow} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rakettiTransparentYellow} download='rakettiTransparentYellow'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rakettiTransparentPink600} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rakettiTransparentPink600} download='rakettiTransparentPink600'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rakettiTransparentPink800} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rakettiTransparentPink800} download='rakettiTransparentPink800'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rakettiTransparentYellow600} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rakettiTransparentYellow600} download='rakettiTransparentYellow600'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rakettiTransparentYellow800} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rakettiTransparentYellow800} download='rakettiTransparentYellow800'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Rocket Riches Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesLogo} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesLogo} download='rocketRichesLogo'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesH} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesH} download='rochetRichesH'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesV} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesV} download='rocketRichesV'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesBgBlack300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesBgBlack300x300} download='rocketRichesBgBlack300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesBgBlack400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesBgBlack400x240} download='rocketRichesBgBlack400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesBgPink300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesBgPink300x300} download='rocketRichesBgPink300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesBgPink400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesBgPink400x240} download='rocketRichesBgPink400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesBgYellow300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesBgYellow300x300} download='rocketRichesBgYellow300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesBgYellow400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesBgYellow400x240} download='rocketRichesBgYello400x240'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesGreenText} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesGreenText} download='rocketRichesGreenText'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesPinkText} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesPinkText} download='rocketRichesPinkText'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={rocketRichesYellowText} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={rocketRichesYellowText} download='rocketRichesYellowText'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Paratiisi Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiLogoMandarine256x40} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiLogoMandarine256x40} download='paratiisiLogoMandarine256x40'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiLogoDragon256x40} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiLogoDragon256x40} download='paratiisiLogoDragon256x40'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGPattern300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGPattern300x140} download='paratiisiBGPattern300x140'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGPattern200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGPattern200x100} download='paratiisiBGPattern200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGParadise300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGParadise300x140} download='paratiisiBGParadise300x140'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGParadise200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGParadise200x100} download='paratiisiBGParadise200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGMagnolia300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGMagnolia300x140} download='paratiisiBGMagnolia300x140'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGMagnolia200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGMagnolia200x100} download='paratiisiBGMagnolia200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGImage300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGImage300x140} download='paratiisiBGImage300x140'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGImage200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGImage200x100} download='paratiisiBGImage200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGBlackberry300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGBlackberry300x140} download='paratiisiBGBlackberry300x140'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={paratiisiBGBlackberry200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={paratiisiBGBlackberry200x100} download='paratiisiBGBlackberry200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Big Lucky Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyGreenBGGoldWhite200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyGreenBGGoldWhite200x100} download='bigLuckyGreenBGGoldWhite200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyGreenBGGoldWhite300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyGreenBGGoldWhite300x140} download='bigLuckyGreenBGGoldWhite300x140'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyGreenBGGoldWhite400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyGreenBGGoldWhite400x240} download='bigLuckyGreenBGGoldWhite400x240'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyWhiteBGGreen200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyWhiteBGGreen200x100} download='bigLuckyWhiteBGGreen200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyWhiteBGGreen300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyWhiteBGGreen300x140} download='bigLuckyWhiteBGGreen300x140'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyWhiteBGGreen400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyWhiteBGGreen400x240} download='bigLuckyWhiteBGGreen400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyIconGreenBGGold1024x1024} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyIconGreenBGGold1024x1024} download='bigLuckyIconGreenBGGold1024x1024'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={bigLuckyIconWhiteBGGreen1024x1024} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyIconWhiteBGGreen1024x1024} download='bigLuckyIconWhiteBGGreen1024x1024'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={bigLuckyVerticalGreenBGGoldWhite300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyVerticalGreenBGGoldWhite300x300} download='bigLuckyVerticalGreenBGGoldWhite300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={bigLuckyVerticalGreenBGGoldWhite400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyVerticalGreenBGGoldWhite400x240} download='bigLuckyVerticalGreenBGGoldWhite400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={bigLuckyVerticalWhiteBGGreen300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyVerticalWhiteBGGreen300x300} download='bigLuckyVerticalWhiteBGGreen300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={bigLuckyVerticalWhiteBGGreen400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={bigLuckyVerticalWhiteBGGreen400x240} download='bigLuckyVerticalWhiteBGGreen400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Ruhtinas Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasBlueBgGold200x89} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasBlueBgGold200x89} download='ruhtinasBlueBgGold200x89'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasBlueBgGold200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasBlueBgGold200x100} download='ruhtinasBlueBgGold200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasBlueBgGold300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasBlueBgGold300x140} download='ruhtinasBlueBgGold300x140'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasBlueBgGold400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasBlueBgGold400x240} download='ruhtinasBlueBgGold400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasCrownLogoBlueBgGold400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasCrownLogoBlueBgGold400x240} download='ruhtinasCrownLogoBlueBgGold400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasCrownLogoWhiteBgGold400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasCrownLogoWhiteBgGold400x240} download='ruhtinasCrownLogoWhiteBgGold400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasVerticalBlueBgDarkGold300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasVerticalBlueBgDarkGold300x300} download='ruhtinasVerticalBlueBgDarkGold300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={ruhtinasVerticalTransparentBgDarkGold250x250} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasVerticalTransparentBgDarkGold250x250} download='ruhtinasVerticalTransparentBgDarkGold250x250'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasVerticalTransparentBgGold250x250} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasVerticalTransparentBgGold250x250} download='ruhtinasVerticalTransparentBgGold250x250'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasVerticalTransparentBgGold300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasVerticalTransparentBgGold300x300} download='ruhtinasVerticalTransparentBgGold300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasVerticalWhiteBgGold300x3001} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasVerticalWhiteBgGold300x3001} download='ruhtinasVerticalWhiteBgGold300x3001'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasVerticalWhiteBgGold300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasVerticalWhiteBgGold300x300} download='ruhtinasVerticalWhiteBgGold300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasWhiteBgGold200x89} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasWhiteBgGold200x89} download='ruhtinasWhiteBgGold200x89'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasWhiteBgGold200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasWhiteBgGold200x100} download='ruhtinasWhiteBgGold200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasWhiteBgGold300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasWhiteBgGold300x140} download='ruhtinasWhiteBgGold300x140'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={ruhtinasWhiteBgGold400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={ruhtinasWhiteBgGold400x240} download='ruhtinasWhiteBgGold400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Regal Rush Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushBlueBGGold200x89} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushBlueBGGold200x89} download='regalRushBlueBGGold200x89'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushBlueBGGold200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushBlueBGGold200x100} download='regalRushBlueBGGold200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushBlueBGGold300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushBlueBGGold300x140} download='regalRushBlueBGGold300x140'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushBlueBGGold420x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushBlueBGGold420x240} download='regalRushBlueBGGold420x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushCrownLogoBlueBGGold400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushCrownLogoBlueBGGold400x240} download='regalRushCrownLogoBlueBGGold400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushCrownLogoWhiteBGGold400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushCrownLogoWhiteBGGold400x240} download='regalRushCrownLogoWhiteBGGold400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushVerticalBlueBGDarkGold300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushVerticalBlueBGDarkGold300x300} download='regalRushVerticalBlueBGDarkGold300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={regalRushVerticalTransparentBGDarkGold250x250} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushVerticalTransparentBGDarkGold250x250} download='regalRushVerticalTransparentBGDarkGold250x250'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushVerticalTransparentBGGold250x250} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushVerticalTransparentBGGold250x250} download='regalRushVerticalTransparentBGGold250x250'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushVerticalTransparentBGGold300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushVerticalTransparentBGGold300x300} download='regalRushVerticalTransparentBGGold300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushVerticalWhiteBGGold300x3001} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushVerticalWhiteBGGold300x3001} download='regalRushVerticalWhiteBGGold300x3001'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushVerticalWhiteBGGold300x300} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushVerticalWhiteBGGold300x300} download='regalRushVerticalWhiteBGGold300x300'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushWhiteBGGold200x89} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushWhiteBGGold200x89} download='regalRushWhiteBGGold200x89'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushWhiteBGGold200x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushWhiteBGGold200x100} download='regalRushWhiteBGGold200x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushWhiteBGGold300x140} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushWhiteBGGold300x140} download='regalRushWhiteBGGold300x140'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={regalRushWhiteBGGold400x240} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={regalRushWhiteBGGold400x240} download='regalRushWhiteBGGold400x240'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Panosta Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panosta80x80} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panosta80x80} download='panosta80x80'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panosta100x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panosta100x100} download='panosta100x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panosta120x120} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panosta100x100} download='panosta100x100'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panosta120x120} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panosta120x120} download='panosta120x120'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panosta150x150} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panosta150x150} download='panosta150x150'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panostasvg80x80} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostasvg80x80} download='panostasvg80x80'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panostasvg100x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostasvg100x100} download='panostasvg100x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={panostasvg120x120} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostasvg120x120} download='panostasvg120x120'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={panostasvg150x150} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostasvg150x150} download='panostasvg150x150'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={panostasvg250x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostasvg250x100} download='panostasvg250x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={panostasvg300x100} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostasvg300x100} download='panostasvg300x100'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={panostasvg600x200} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostasvg600x200} download='panostasvg600x200'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={panostabackground} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostabackground} download='panostabackground'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={panostawhitebackground} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={panostawhitebackground} download='panostawhitebackground'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="logos-header">
        <h5 className="logos-title">
          Chill Spins Logos
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins80x80Transparent} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins80x80Transparent} download='chillSpins80x80Transparent'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins80x80Dark} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins80x80Dark} download='chillSpins80x80Dark'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins120x120Transparent} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins120x120Transparent} download='chillSpins120x120Transparent'>
            <button type='button' className='brand_button'>Download </button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins120x120Dark} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins120x120Dark} download='chillSpins120x120Dark'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins150x150Transparent} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins150x150Transparent} download='chillSpins150x150Transparent'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins150x150Dark} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins150x150Dark} download='chillSpins150x150Dark'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins300x300Transparent} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins300x300Transparent} download='chillSpins300x300Transparent'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins300x300Dark} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins300x300Dark} download='chillSpins300x300Dark'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins600x200Transparent} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins600x200Transparent} download='chillSpins600x200Transparent'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
          <div className="brands_height">
            <img src={chillSpins600x200Dark} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins600x200Dark} download='chillSpins600x200Dark'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={chillSpins1024x458Transparent} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins1024x458Transparent} download='chillSpins1024x458Transparent'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
        <div className="col-lg-2 col-12 mb-5 logos_align">
        <div className="brands_height">
            <img src={chillSpins1024x458Dark} alt='logo' width='60%' className="mb-3" />
          </div>
          <br />
          <a href={chillSpins1024x458Dark} download='chillSpins1024x458Dark'>
            <button type='button' className='brand_button'>Download</button>
          </a>
        </div>
      </div>
    </div>
  );
};
